"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPlacesAutocomplete = _interopRequireWildcard(require("react-places-autocomplete"));

var _LabeledInput = _interopRequireDefault(require("../LabeledInput"));

var _button = require("../../../styles/2_commonComponentStyles/button");

var _AddressAutoComplete = require("./AddressAutoComplete.styles");

var _DropdownButton = _interopRequireDefault(require("../../Buttons/DropdownButton"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Price display component
 */
var AddressAutoComplete = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AddressAutoComplete, _React$PureComponent);

  var _super = _createSuper(AddressAutoComplete);

  function AddressAutoComplete(props) {
    var _this;

    _classCallCheck(this, AddressAutoComplete);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "searchOptions", {
      types: ['address']
    });

    _this.onErrorHandler = _this.onErrorHandler.bind(_assertThisInitialized(_this));
    _this.onInputHandler = _this.onInputHandler.bind(_assertThisInitialized(_this));
    _this.onSelectHandler = _this.onSelectHandler.bind(_assertThisInitialized(_this));
    _this.onSuiteInputHandler = _this.onSuiteInputHandler.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AddressAutoComplete, [{
    key: "onErrorHandler",
    value: function onErrorHandler(address) {
      return this.props.onErrorHandler && this.props.onErrorHandler(address);
    }
  }, {
    key: "onInputHandler",
    value: function onInputHandler(address) {
      return this.props.onInputHandler && this.props.onInputHandler(address);
    }
  }, {
    key: "onSelectHandler",
    value: function onSelectHandler(address) {
      var _this2 = this;

      (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (results) {
        // eslint-disable-line arrow-body-style

        /** results contain array of address components that map to individual parts of the address
         * e.g., street number, name, city, state, zip, etc
         * */
        return _this2.props.onGoogleAPIReturn(results);
      });
      return this.props.onSelectHandler && this.props.onSelectHandler(address);
    }
  }, {
    key: "onSuiteInputHandler",
    value: function onSuiteInputHandler(e) {
      return this.props.onSuiteInputHandler && this.props.onSuiteInputHandler(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          address = _this$props.address,
          className = _this$props.className,
          colorTheme = _this$props.colorTheme,
          dataTestId = _this$props.dataTestId,
          error = _this$props.error,
          label = _this$props.label,
          onErrorHandler = _this$props.onErrorHandler,
          onInputHandler = _this$props.onInputHandler,
          onSelectHandler = _this$props.onSelectHandler,
          placeholder = _this$props.placeholder,
          showSuite = _this$props.showSuite,
          suite = _this$props.suite,
          suiteError = _this$props.suiteError,
          leftIcons = _this$props.leftIcons,
          rightIcons = _this$props.rightIcons,
          props = _objectWithoutProperties(_this$props, ["address", "className", "colorTheme", "dataTestId", "error", "label", "onErrorHandler", "onInputHandler", "onSelectHandler", "placeholder", "showSuite", "suite", "suiteError", "leftIcons", "rightIcons"]);

      return /*#__PURE__*/_react.default.createElement(_AddressAutoComplete.StyledAddressAutoComplete, {
        className: className,
        "data-test-id": dataTestId
      }, /*#__PURE__*/_react.default.createElement(_reactPlacesAutocomplete.default, _extends({
        className: className,
        "data-test-id": dataTestId,
        debounce: 200,
        onChange: this.onInputHandler,
        onError: this.onErrorHandler,
        onSelect: this.onSelectHandler,
        searchOptions: this.searchOptions,
        value: address
      }, props), function (_ref) {
        var getInputProps = _ref.getInputProps,
            getSuggestionItemProps = _ref.getSuggestionItemProps,
            suggestions = _ref.suggestions;
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_AddressAutoComplete.StyledLabeledInput, getInputProps({
          dataTestId: 'address-auto-complete-address-input',
          error: error,
          id: 'addressAutoComplete',
          label: label,
          leftIcons: leftIcons,
          name: 'addressAutoComplete',
          placeholder: placeholder,
          rightIcons: rightIcons
        })), suggestions && suggestions.length > 0 && /*#__PURE__*/_react.default.createElement(_AddressAutoComplete.StyledSuggestionsWrapper, {
          colorTheme: colorTheme,
          "data-test-id": "address-auto-complete-suggestions-wrapper",
          hasLabel: !!label
        }, suggestions.map(function (suggestion) {
          return /*#__PURE__*/_react.default.createElement(_DropdownButton.default, _extends({
            role: "presentation",
            className: suggestion.active ? 'c-button-focus' : '' // this is needed because placesAutocomplete treats what should be focus instead as active
            ,
            dataTestId: "address-for-".concat(suggestion.description),
            key: "address-for-".concat(suggestion.description)
          }, getSuggestionItemProps(suggestion, {
            className: className
          })), suggestion.description);
        })));
      }), showSuite && /*#__PURE__*/_react.default.createElement(_LabeledInput.default, {
        dataTestId: "address-auto-complete-places-suite-input",
        error: suiteError,
        label: "Suite or Apt # (optional):",
        name: "suite",
        onChange: this.onSuiteInputHandler,
        value: suite
      }));
    }
  }]);

  return AddressAutoComplete;
}(_react.default.PureComponent);

_defineProperty(AddressAutoComplete, "propTypes", {
  /** Value */
  address: _propTypes.default.string,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Icon Color */
  colorTheme: _propTypes.default.oneOf(_button.buttonColorThemes),

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Error Message for Google Places input */
  error: _propTypes.default.string,

  /** Label of address auto correct */
  label: _propTypes.default.string,

  /** Handle error */
  onErrorHandler: _propTypes.default.func,

  /** onGoogleAPIReturn error */
  onGoogleAPIReturn: _propTypes.default.func,

  /** Handle input field change  */
  onInputHandler: _propTypes.default.func,

  /** Handler for when user selects address. */
  onSelectHandler: _propTypes.default.func,

  /** Handler for when user changes suite input. */
  onSuiteInputHandler: _propTypes.default.func,

  /** Placeholder */
  placeholder: _propTypes.default.string,

  /** Whether to show the suite input field. */
  showSuite: _propTypes.default.bool,

  /** Value of suite input */
  suite: _propTypes.default.string,

  /** Suite error message */
  suiteError: _propTypes.default.string,
  // ICONS //

  /** Icons or IconButtons to display to the left of the input field. */
  leftIcons: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element])),

  /** Icons or IconButtons to display to the right of the input field. */
  rightIcons: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element]))
});

_defineProperty(AddressAutoComplete, "defaultProps", {
  address: '',
  className: '',
  colorTheme: 'primary',
  error: '',
  label: '',
  onErrorHandler: function onErrorHandler() {},
  onGoogleAPIReturn: function onGoogleAPIReturn() {},
  onInputHandler: function onInputHandler() {},
  onSelectHandler: function onSelectHandler() {},
  onSuiteInputHandler: function onSuiteInputHandler() {},
  placeholder: '',
  showSuite: true,
  suite: '',
  suiteError: '',
  // icons
  leftIcons: [],
  rightIcons: []
});

var _default = AddressAutoComplete;
exports.default = _default;